import { Box } from '@hivebrite/design-system/Box';

import SharedContentThumbnail from 'hb-react/frontoffice/components/ShareContentModal/components/SharedContentThumbnail';
import SharedFolderThumbnail from 'hb-react/frontoffice/components/ShareContentModal/components/SharedFolderThumbnail';

const AssociatedRecordContent = ({ fromRecord }) => {
  if (!fromRecord) {
    return null;
  }

  switch (fromRecord.type) {
    case 'MediaCenter::Folder':
      return (
        <Box mt={2} display="block">
          <SharedFolderThumbnail fromRecord={fromRecord} />
        </Box>
      );
    case 'MediaCenter::File':
    case 'Article':
      return (
        <Box mt={2} display="block">
          <SharedContentThumbnail fromRecord={fromRecord} />
        </Box>
      );
    default:
      return null;
  }
};

export default AssociatedRecordContent;
